export default "__VITE_ASSET__DPaxJAkV__"